
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success-stories/web-neobanking",
      function () {
        return require("private-next-pages/success-stories/web-neobanking/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/success-stories/web-neobanking"])
      });
    }
  